import React, { useEffect, useState , useMemo } from 'react';
import '@ant-design/compatible/assets/index.css';
import { Col, Divider, Input, Row, Spin, Switch } from 'antd';
import Text from 'antd/lib/typography/Text';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import { getThirdPartyById, TpBankAccount } from 'services/thirdParty';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import ParListSelect from 'components/ParListSelect';
import Value from 'components/Value';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Title from 'components/Title';
import Bank from 'components/Bank';
import { useQuery } from 'react-query';
export type TabTPChangeBankAccountProps = {
  objectid?: number;
  form: FormInstance;
  formTP?: FormInstance;
  tpbadate?: TpBankAccount;
  tptype?: string;
  countcode?: string;
  setSuccessful: any;
};

const TabTPChangeBankAccount = ({
  tptype,
  objectid,
  form,
  countcode,
  setSuccessful,
}: TabTPChangeBankAccountProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState<any>({
    bankAccount: {},
    generalData: {},
  });

  const stableObjectId = useMemo(() => objectid, [objectid]);
  
  const { data, isFetching, refetch } = useQuery(
    ['getThirdPartyById', { tpid: stableObjectId }],
    () => getThirdPartyById({ tpid: stableObjectId! }).then((res) => res.data),
    {
      enabled: false,
    }
  );
  
  useEffect(() => {
    if (stableObjectId) {
      refetch();
    }
  }, [stableObjectId, refetch]);

  const lancode = localStorage.getItem('lancode');
  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (countcode) {
      form.setFieldsValue({
        countcode: countcode,
      });
    }
    if (data) {
      const { generalData } = data;

      form?.setFieldsValue({
        countcode: generalData.countcode,
      });
    }
  }, [countcode, data, form]);
  return (
    <DF.Provider pagcode="TabTPBankAccount">
      <Spin spinning={isFetching}>
        <Row>
          <Col xs={3}>
            <FormInput name="flagapplytoall" noStyle>
              <Switch
                checkedChildren={<GetLabel label="change&apply" />}
                unCheckedChildren={<GetLabel label="only&add" />}
              />
            </FormInput>
          </Col>

          <Col span={24}>
            <Divider orientation="left"></Divider>
            {form.getFieldValue('flagapplytoall') === true && (
              <div>
                <Row>
                  <Title comcode="bkAccountToReplace" level={4} />
                </Row>
                <Row>
                  <Col span={24}>&nbsp;</Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormInput
                      name="tpbkid"
                      rules={[{ required: true }]}
                      comcode="selectanAccount"
                    >
                      <BankAccountListSelect
                        params={{ tpid: objectid ?? 0 }}
                        onSelected={(e) =>
                          form?.setFieldsValue({
                            bktype: e?.bktype,
                            bktypelabel: e?.bktypelabel,
                            bkstatuslabel: e?.bkstatuslabel ?? 'VALID',
                          })
                        }
                      />
                    </FormInput>
                  </Col>
                  <Col xs={2}>
                    <Text>
                      <GetLabel label="thisAccountIs" />
                    </Text>
                  </Col>
                  <Col xs={4}>
                    <FormInput
                      noStyle
                      name="bktypelabel"
                      style={{ color: 'blue' }}
                    >
                      <Value />
                    </FormInput>
                    <Form.Item noStyle name="bktype" hidden>
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col xs={4}>
                    <FormInput name="bkstatuslabel" style={{ color: 'green' }}>
                      <Value />
                    </FormInput>
                  </Col>
                </Row>
              </div>
            )}
            <Divider orientation="left"></Divider>
            <Row>
              <Title comcode="newAccountDetail" level={4} />
            </Row>
            <Row gutter={8}>
              <FormInput col xs={5} labelCol={{ span: 4 }} name="bktype" hidden>
                <ParListSelect parcode="PAYDIR" />
              </FormInput>

              <FormInput col xs={4} labelCol={{ span: 5 }} name="currcode">
                <ParListSelect parcode="CURRENCY" />
              </FormInput>
            </Row>

            <Row gutter={8}>
              <Bank
                countcode={
                  countcode ? countcode : form.getFieldValue('countcode')
                }
                currcode={form.getFieldValue('currcode')}
                form={form}
                ibanField="tpiban"
                bankField="bkcode"
                branchField="bkbranchcode"
                notRequired
                cbkeyField="bkaccountkey"
                cbnumField="bkaccountnum"
                Colw={{ span: 16 }}
                lancode={lancode}
                labelcol={{ span: 4 }}
              />
            </Row>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabTPChangeBankAccount;
